// extracted by mini-css-extract-plugin
export default {"rangeSelect":"ChartTemplate_rangeSelect__xTZaR","rangeSelectIcon":"ChartTemplate_rangeSelectIcon__BtjyM","ersteLogo":"ChartTemplate_ersteLogo__N+Nkc"};